function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPsychology = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 42 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.29,0.834C17.623,0.834 19.518,2.729 19.518,5.062L19.518,35.261C19.518,37.594 17.623,39.489 15.29,39.489C13.108,39.489 11.311,37.836 11.085,35.707C10.692,35.812 10.277,35.865 9.854,35.865C7.189,35.865 5.022,33.698 5.022,31.033C5.022,30.475 5.12,29.931 5.294,29.433C3.014,28.572 1.398,26.368 1.398,23.786C1.398,21.377 2.81,19.293 4.856,18.327C4.199,17.504 3.814,16.462 3.814,15.33C3.814,13.012 5.445,11.079 7.619,10.604C7.499,10.189 7.438,9.743 7.438,9.29C7.438,7.033 8.993,5.13 11.085,4.602C11.311,2.488 13.108,0.834 15.29,0.834ZM26.161,0.834C28.343,0.834 30.133,2.488 30.367,4.602C32.465,5.13 34.013,7.025 34.013,9.29C34.013,9.743 33.953,10.189 33.832,10.604C36.006,11.072 37.637,13.012 37.637,15.33C37.637,16.462 37.252,17.504 36.595,18.327C38.641,19.293 40.053,21.377 40.053,23.786C40.053,26.368 38.437,28.572 36.157,29.433C36.331,29.931 36.429,30.475 36.429,31.033C36.429,33.698 34.262,35.865 31.597,35.865C31.174,35.865 30.759,35.812 30.367,35.707C30.14,37.836 28.343,39.489 26.161,39.489C23.829,39.489 21.934,37.594 21.934,35.261L21.934,5.062C21.934,2.729 23.829,0.834 26.161,0.834Z",
    style: {
      fill: "rgb(0,101,157)",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPsychology);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/psychology.2d97203727d428401a9adde7156b191e.svg";